import { QueryKey } from '@gogame/query';

export const businessKey = new QueryKey('business');
export const userKey = new QueryKey('user');
export const notificationsKey = new QueryKey('notifications');
export const coreKey = new QueryKey('core');
export const SAME = 'same';
export const NOT_SAME = 'notSame';
export const ALL = 'all';
